import { RescueModule } from './investments/rescue/rescue.module';
import { ReceiptsModule } from './receipts/receipts.module';
import { LimitsModule } from './limits/limits.module';
import { SharedModule } from './../shared/shared.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterComponent } from './master.component';
import { MasterGuard } from './master.guard';
import { ExtractModule } from './extract/extract.module';
import { TransfersOtherBanksModule } from './transfers-other-banks/transfers-other-banks.module';
import { AppRoutingModule } from '../app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransfersOmniModule } from './transfers-omni/transfers-omni.module';
import { InvestmentsSimulationModule } from './investments/investments-simulation/investments-simulation.module';
import { InvestmentsExtractModule } from './investments/investments-extract/investments-extract.module';
import { InvestmentsPeriodModule } from './investments/investments-period/investments-period.module';
import { RedeemBalanceModule } from './investments/redeem-balance/redeem-balance.module';
import { PaymentSecuritiesModule } from './payment-securities/payment-securities.module';
import { PaymentFederalTaxesModule } from './payment-federal-taxes/payment-federal-taxes.module';
import { ChangePassModule } from './change-pass/change-pass.module';
import { TransactionHistoryModule } from './transaction-history/transaction-history.module';
import { UserAdminModule } from './user-admin/user-admin.module';
import { RenameYourAccountModule } from './rename-your-account/rename-your-account.module';
import { ChangeDigitalSignatureModule } from './change-digital-signature/change-digital-signature.module';
import { DepositPerTicketModule } from './deposit-per-ticket/deposit-per-ticket.module';
import { CustomerServiceModule } from './customer-service/customer-service.module';
import { RegisterOfBenefactorsModule } from './register-of-benefactors/register-of-benefactors.module';
import { ReportIncomeModule } from './report-income/report-income.module';
import { RatePackageModule } from './rate-package/rate-package.module';
import { CardsActivationModule } from './cards-activation/cards-activation.module';
import { CardsModule } from './cards/cards.module';
import { ChangeSecurityQuestionsModule } from './change-security-questions/change-security-questions.module';
import { CollectionModule } from './collection/collection.module';
import { PixModule } from './pix/pix.module';
import { CloseAccountModule } from './close-account/close-account.module';
import { TermsOfUseModule } from './terms-of-use/terms-of-use.module';
import { LimiteGlobalModule } from './limite-global/limite-global.module';
import { AntifraudWarningModule } from './antifraud-warning/antifraud-warning.module';
import { DeviceManagementModule } from './device-management/device-management.module';

@NgModule({
	imports: [
		CommonModule,
		DashboardModule,
		ExtractModule,
		TransfersOtherBanksModule,
		TransfersOmniModule,
		SharedModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		PaymentSecuritiesModule,
		LimitsModule,
		InvestmentsSimulationModule,
		InvestmentsExtractModule,
		InvestmentsPeriodModule,
		RedeemBalanceModule,
		PaymentSecuritiesModule,
		ReceiptsModule,
		RescueModule,
		PaymentFederalTaxesModule,
		ChangePassModule,
		TransactionHistoryModule,
		UserAdminModule,
		RenameYourAccountModule,
		ChangeDigitalSignatureModule,
		DepositPerTicketModule,
		CustomerServiceModule,
		RegisterOfBenefactorsModule,
		ReportIncomeModule,
		RatePackageModule,
		CardsActivationModule,
		ChangeSecurityQuestionsModule,
		CardsModule,
		CollectionModule,
		LimiteGlobalModule,
		PixModule,
		CloseAccountModule,
		DeviceManagementModule,
		TermsOfUseModule,
		AntifraudWarningModule
	],
	declarations: [
		MasterComponent,
	],
	providers: [
		MasterGuard
	],
	exports: [MasterComponent]
})
export class MasterModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/master.module.ts